import { render, staticRenderFns } from "./com-image.vue?vue&type=template&id=9ec5536c&scoped=true"
import script from "./com-image.vue?vue&type=script&lang=js"
export * from "./com-image.vue?vue&type=script&lang=js"
import style0 from "./com-image.vue?vue&type=style&index=0&id=9ec5536c&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ec5536c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9ec5536c')) {
      api.createRecord('9ec5536c', component.options)
    } else {
      api.reload('9ec5536c', component.options)
    }
    module.hot.accept("./com-image.vue?vue&type=template&id=9ec5536c&scoped=true", function () {
      api.rerender('9ec5536c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/modulestore/components/com-image.vue"
export default component.exports